import { render, staticRenderFns } from "./PickingReturnFormDialog.vue?vue&type=template&id=7060b722"
import script from "./PickingReturnFormDialog.vue?vue&type=script&lang=js"
export * from "./PickingReturnFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports